import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints';

const StyledComp = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  color: rgb(var(--whiter));
  height: 1000px;
  margin-bottom: 200px;

  @media (max-width: ${breakpoints.small}) {
    height: 1300px;
    margin-bottom: 20px;
  }
  .bg-image {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }

  .overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(var(--blackr), 0.5) 0%,
      rgba(var(--blackr), 0.25) 35%,
      rgba(var(--blackr), 0.05) 65%,
      rgba(var(--blackr), 0) 100%
    );
    z-index: 1;
  }

  .content {
    position: relative;
    z-index: 2;
    padding: 64px 40px 56px;
    max-width: 1400px;
    margin: 0 auto;
  }

  .heading {
    margin: 0 0 40px;
    max-width: 440px;
    font-size: 48px;
    line-height: 1.35;
    color: rgb(var(--whiter));
  }

  .text-row {
    display: flex;
    gap: 48px;
    align-items: flex-start;
  }

  .text-col {
    flex: 1;
    min-width: 0;
  }

  .text-col p {
    margin: 0;
    font-size: 12px;
    line-height: 1.7;
    color: rgba(var(--whiter), 0.75);
  }

  .cta-col {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    gap: 24px;
  }

  .cta-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: rgb(var(--whiter));
    text-decoration: none;
    opacity: 0.85;
    white-space: nowrap;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 1;
    }
  }

  .cta-link .arrow {
    font-size: 13px;
    transition: transform 0.2s ease;
  }

  .cta-link:hover .arrow {
    transform: translateX(3px);
  }

  @media (max-width: 900px) {
    .text-row {
      flex-direction: column;
      gap: 24px;
    }

    .cta-col {
      align-items: flex-start;
    }
  }
  @media (max-width: ${breakpoints.small}) {
    .content {
      padding: 40px 24px;
    }
  }
`;

const Comp = ({ }) => {
  return (
    <StyledComp>
      <img className="bg-image" src='/about/l2.jpg' alt='decorative background'/>
      <div className="overlay" />
      <div className="content">
        <h2 className="heading serif">Every dataset your research needs, in one financial data API</h2>
        <div className="text-row">
          <div className="text-col">
            <p>Market data, fundamentals, alternative data, and quant tools have always lived in different places. One vendor covers stock prices. Another covers SEC filings. A third covers sentiment or supply chain data. Analysts and engineers spend as much time reconciling formats and stitching APIs together as they do actually researching a company.</p>
          </div>
          <div className="text-col">
            <p>Axion brings all of it into one financial data platform. Stocks, crypto, forex, futures, and indices sit alongside fundamentals, filings, insider activity, sentiment, ESG scores, credit ratings, supply chain mapping, and economic data, all accessible through a single Python SDK and REST API built for structured, model-ready output.</p>
          </div>
          <div className="text-col cta-col">
            <p>Axion is built for quant teams, fintech builders, and hedge funds who need dependable, structured data without maintaining a patchwork of vendor contracts, and without waiting weeks to get a new dataset into production.</p>
            <a className="cta-link" href='/products'>
               Explore products
              <span className="arrow" aria-hidden="true">
                &rarr;
              </span>
            </a>
          </div>
        </div>
      </div>
    </StyledComp>
  );
};

export default Comp;
